module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-15-13.098Z.db4cbab6.png";